import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {GetChatRoom, GetChatParams, GetChatModel} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemoteGetChatRoom implements GetChatRoom {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetChatModel>,
	) {}

	async get(params: GetChatParams): Promise<GetChatModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
